import ImgCzujnik from './czujnik.png';
import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Login from "../Login";
import AuthService from "../../services/auth.service";
import ParkingList from "../../parkings/ParkingList";
import SmartSensingLogo from './SmartSensing.png';
import PolandPrizeLogo from './polandPrize.jpeg';
import BraveLogo from './brave.png';
import Logotypy1 from './logotypy1.png';
import ParpLogo from './parp.jpeg';
import TrafficTracker from './smart2sensing_traffic_tracker_kskgr01_image.png';

import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import i18n from '../../i18n';


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  width: "60%",
  margin: '20'

}));

const homeStyle = {
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  backgroundColor: 'red',
};
const useStyles = makeStyles({
  paragraph: {
    margin: '16px', // tu ustaw margines, np. 16 pikseli
  },
});
const imgStyle = {
  width: "40%"
};
const theme = createTheme();

theme.typography.h6 = {
  fontSize: '0.8rem',
  '@media (min-width:600px)': {
    fontSize: '1.0rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.2rem',
  },
};



 function Home() {


   useEffect(() => {
   document.title = 'SMARTSENSING Innovations are comming'; // ustawienie nowego tytułu
 }, []);
     const { t } = useTranslation("common");
   let navigate = useNavigate();
   const [showModeratorBoard, setShowModeratorBoard] = useState(false);
   const [showAdminBoard, setShowAdminBoard] = useState(false);
   const [currentUser, setCurrentUser] = useState(undefined);
   useEffect(() => {
     const user = AuthService.getCurrentUser();
     if (user) {
       setCurrentUser(user);
       setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
       setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
     }
   }, []);
   AuthService.logout();
   if(currentUser)
   {
    navigate("/parkings");
      window.location.reload();
   }
  // const classes = useStyles()
   return (

     <div>
     <center>
     <br/>
    <img src={SmartSensingLogo} />


<ThemeProvider theme={theme}>
    <Box
      sx={{
        p: 2,

        gap: 2,
        fontFamily: '',
        color: '#1061af'
      }}
    >

        <Item
        sx={{
          p: 5,
          gap: 2,
          fontFamily: '',
          color: '#1061af'

        }}
        elevation='24'  >
        <Typography variant="h6">
{t('toolbar.text1')}
        </Typography>
        <br/>
        <Typography variant="h6">
{t('toolbar.text2')}
       </Typography>
        <br/>
        <Typography variant="h6">
{t('toolbar.text3')}
        </Typography>
        </Item>

    </Box>



    <br/>
    <Typography variant="h4" color="#1061af">
    Traffic Tracker GR01
    </Typography>
      <img src={TrafficTracker} height='300'/>
    <Box
      sx={{
        p: 2,
        bgcolor: 'background.default',
        gap: 2,
      }}
    >
    <Item
    sx={{
      p: 5,
      color: '#1061af',
      gap: 2,
      fontFamily: '',
    }}
    elevation='24'>
    <Typography variant="h6">
{t('toolbar.text4')}
    </Typography>
    <br/>
    <Typography variant="h6">
{t('toolbar.text5')}
    </Typography>
    <br/>
    <Typography variant="h6">
{t('toolbar.text6')}
    </Typography>

    </Item>
    </Box>

    <Box
      sx={{
        p: 2,
        bgcolor: 'background.default',

        gap: 2,
      }}
    >

    <Item
    sx={{
      p: 5,

      gap: 2,
      fontFamily: '',
    }}
    elevation='24'>
        <Typography variant="span">
        SMARTSENSING
        <br/>
        SPÓŁKA Z OGRANICZONĄ
        ODPOWIEDZIALNOŚCIĄ
        <br/>
        Towarowa 13
        <br/>
        11-041 Olsztyn
        <br/>
        NIP: 7393975712
        </Typography>
        </Item>

    </Box>
</ThemeProvider>

<br/>
<br/>
Projekt SMARTSENSING powstaje dzięki inwestycji funduszu Brave Seed Fund sp. z o.o. Fundusz Kapitałowy Warmii i Mazur ASI sp. k.
<br/><img src={BraveLogo} />
<br/>
<img src={Logotypy1} />
<br/>
<img src={PolandPrizeLogo} />
<br/>
<img src={ParpLogo} />
  </center>


    </div>


  );
 }
export default Home;
